import { EmptyState, Grid, GridRow } from '@bp/ui-components';
import { AssignmentMaterialCard } from 'components/Assignments/components/AssignmentMaterialCard/AssignmentMaterialCard';
import { BpHeader } from 'components/BpHeader/BpHeader';
import { BpSubpage } from 'components/BpSubpage/BpSubpage';
import { PublicSubmissionCard } from 'components/Submissions/components/PublicSubmissionCard/PublicSubmissionCard';
import { useSubmissions } from 'components/Submissions/hooks/useSubmissions';
import { useRequireParams } from 'hooks/useRequireParams';
import { useTranslation } from 'react-i18next';

export const CoursePublicSubmissionsSubpage = () => {
  const { t } = useTranslation();
  const { courseUuid, assignmentUuid } = useRequireParams(['courseUuid', 'assignmentUuid']);

  const { submissions } = useSubmissions({ courseUuid, assignmentUuid });

  const publicSubmissions = submissions.filter((s) => s.public);

  return (
    <BpSubpage>
      <BpHeader
        headline={t('submissions.publicAnswers')}
        subHeadline={publicSubmissions.length}
        showSubHeadlineAsChip
        showBackButton
      />
      <Grid>
        <GridRow>
          <AssignmentMaterialCard assignmentUuid={assignmentUuid} showCollapsed />
        </GridRow>
        {publicSubmissions.length === 0 ? (
          <EmptyState className='mt-8' title={t('submissions.noPublicSubmissions')} />
        ) : (
          publicSubmissions.map((s) => {
            return (
              <GridRow>
                <PublicSubmissionCard submissionUuid={s.uuid} />
              </GridRow>
            );
          })
        )}
      </Grid>
    </BpSubpage>
  );
};
